import { styled } from "styled-components";
const TabsWrapper = styled("div")({
  display: "contents"
});
export {
  TabsWrapper
};
